import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import PriceSumCell from './PriceSumCell';

class PriceSumRow extends React.Component {
  render() {
    const { classes, mealTypeSizes, dishSizes, rowType, t } = this.props;

    return (
      <TableRow>
        <TableCell>{t('form.ingredientsDetails.price', 'FoodCost')}</TableCell>
        <TableCell />
        <TableCell />
        {mealTypeSizes.map((mealTypeSize, mealTypeSizeKey) => (
          <PriceSumCell
            rowType={rowType}
            key={mealTypeSizeKey}
            classes={classes}
            size={mealTypeSize.size}
            mealTypeSize={mealTypeSize}
            dishSizes={dishSizes}
          />
        ))}
      </TableRow>
    );
  }
}

export default PriceSumRow;
